import { formatFullAddress, formatPhone, getAttrValue } from 'helpers/Helpers';
import React from 'react'

export default function CreditorContact({creditors}) {

	var contacts = collectContacts(creditors);

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Creditor Contact Information</div>
			</div>
			<div className='text-2xl'>
			{
				contacts.map((c, ix) => {
					return (
						<div key={ix} className={(ix%2)===0 ? "bg-slate-200" : ''}>
							<div className='w-full flex flex-row pl-2 value'>
								<div className='w-[300px]'>{c.Name}</div>
								<div className='w-[300px]'>{c.Rep}</div>
								<div className='w-[300px]'>{c.Code}</div>
							</div>
							<div className='w-full flex flex-row pl-2 value'>
								<div className='w-[600px] pl-7'>{c.Addr}</div>
								<div className='w-[300px]'>{formatPhone(c.Value)}</div>
							</div>
						</div>
					);
				})
			}
			</div>
		</div>
	)
}

function collectContacts(creditors) {

	var contacts = [];
	creditors.forEach((ctr) => {
		var c = {
			Name: '',
			Id: '',
			Sub: '',
			Addr: '',
			Rep: '',
			Code: '',
			Type: '',
			Value: ''
		};

		c.Name = getAttrValue(ctr, "_Name")
		c.Id = getAttrValue(ctr, "CreditTradeReferenceID")
		c.Addr = formatFullAddress(ctr)
		if (!c.Name) c.Name = "-----";

		var cr = ctr.CREDIT_REPOSITORY;
		c.Rep = getAttrValue(cr, "_SourceType");
		c.Code = getAttrValue(cr, "_SubscriberCode");

		var cd = ctr.CONTACT_DETAIL;
		if (cd) {
			var cp = cd.CONTACT_POINT;
			c.Type = getAttrValue(cp, "_Type");
			c.Value = getAttrValue(cp, "_Value");
		};
		let obj = contacts.find(o => o.Code === c.Code);
		if (obj === undefined) {
		 	contacts.push(c)
		}; 
	});

	contacts = contacts.sort(function(a, b) {
		//var tf = (a.Name < b.Name);
		var tf = a.Name.localeCompare(b.Name);
		//console.log(a.Name,b.Name,tf);
		return tf;
	});


	return contacts;
}
